module.exports = __webpack_public_path__ + "images/store_case_study/gameoukoku-pic2_440a68fdd213c49caecadc0652bb8ea3.png";